import React from 'react';
import Landing from '../../publicTemplate/screens/Landing';

const HomePage: React.FC = () => {
  return <Landing />;
};

export default HomePage;
